import { createCustomEvent } from "../../../../javascript/shared/helpers";
import BriefAssociationCollectionController from "./brief-association-collection-controller";

export default class extends BriefAssociationCollectionController {

  connect() {
    App.Helpers.listenToCustomEvent(document, "update-failure", this.replaceFormOnError.bind(this));
    App.Helpers.listenToCustomEvent(document, "form-cancel", this.closeForm.bind(this));
    App.Helpers.listenToCustomEvent(document, "table-refresh", this.updateActivityCount.bind(this));
  }

  //
  // INTERNAL USE
  //

  updateActivityCount(event) {
    this.activitiesCount = event.detail.rows;
  }

  attachFormHandlers() {/* NOT USED - REMOVE WHEN brief-assocation-collection-controller IS REMOVED */}

  //
  // GETTERS AND SETTERS
  //

  get formURL() {
    return this.data.get("new-url");
  }
};



// WEBPACK FOOTER //
// ./app/components/briefs/assets/javascript/briefs-edit-collection-controller.js